import React from 'react';

interface CompleteAllButtonProps {
  onCompleteAll: () => void;
  isCompletingAll: boolean;
  allEvaluated: boolean;
  hasAnyDrafts: boolean;
}

// Complete All Evaluations Button - Bottom Right
const CompleteAllButton: React.FC<CompleteAllButtonProps> = ({
  onCompleteAll,
  isCompletingAll,
  allEvaluated,
  hasAnyDrafts,
}) => {
  return (
    <div className="flex justify-end mt-6">
      <button
        onClick={onCompleteAll}
        disabled={isCompletingAll || !allEvaluated || !hasAnyDrafts}
        className={`px-8 py-3 rounded-full font-baijamjuree font-semibold text-sm transition-all duration-200 ${
          isCompletingAll
            ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
            : allEvaluated && hasAnyDrafts
              ? 'bg-black text-white hover:bg-gray-800 hover:shadow-lg transform hover:scale-105'
              : 'bg-gray-400 text-gray-600 cursor-not-allowed'
        }`}
      >
        {isCompletingAll ? (
          <div className="flex items-center gap-2">
            <div className="animate-spin h-4 w-4 border-2 border-gray-400 border-t-transparent rounded-full"></div>
            Finalizing Evaluations...
          </div>
        ) : (
          'Complete All Evaluations'
        )}
      </button>
    </div>
  );
};

export default CompleteAllButton;
